import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Children, type PropsWithChildren } from 'react';
import { useTabsContext } from '../Tabs';

type TabPanelsProps = {
  className?: string;
};

export const TabPanels = ({
  children,
  className,
}: PropsWithChildren<TabPanelsProps>) => {
  const { activeIndex, id } = useTabsContext();
  const tabPanelsClassName = classNames('TabPanels', className);

  return (
    <div data-testid="tabpanels" className={tabPanelsClassName}>
      {Children.map(children, (child, index) =>
        React.cloneElement(child, {
          'aria-labelledby': `${id}-tab-${index}`,
          id: `${id}-panel-${index}`,
          isActive: index === activeIndex,
        }),
      )}
    </div>
  );
};

TabPanels.displayName = 'TabPanels';
TabPanels.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
